/* eslint-disable import/first, @typescript-eslint/no-var-requires */
import 'core-js/es/map';
import 'core-js/es/set';
import 'promise-polyfill/src/polyfill';
import 'url-search-params-polyfill';

require('array.prototype.find').shim();

import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';

import Routes from './Routes';

import configureStore from './store/configure';
import { defineUser } from './store/user/actions';

import { getUserData } from './services/localSorage';

import SentryContainer from './components/application/SentryContainer';

import Sentry from './monitoring/sentry';

import { GlobalStyles } from './styles';
import { createTheme } from './styles/theme';
import * as Styles from './AppStyles';

import XRayTrackerContainer from './components/application/XRayTrackerContainer/XRayTrackerContainer';
import ZendeskButton from './components/application/ZendeskButton';

const store = configureStore();
const theme = createTheme();

const App: React.FC = () => {
  const { user, token } = getUserData();

  const dispatch = useDispatch();

  const MAX_RETRIES = 3;
  const TIMEOUT = 3000;

  const identifyUserCrazyEgg = (userId: number): void => {
    CE2.identify(userId);
  }

  const retryIdentifyUserCrazyEggWithTimeout = (userId: number, retryCount = 0): void => {
    if (retryCount >= MAX_RETRIES) {
      return;
    }

    try {
      identifyUserCrazyEgg(userId);
    } catch (error) {
      // Aguarda o tempo especificado antes de tentar novamente
      setTimeout(() => {
        retryIdentifyUserCrazyEggWithTimeout(userId, retryCount + 1);
      }, TIMEOUT);
    }
  }

  /*
   * Ao recarregar ou voltar para a aplicação, redefine usuário e token
   */
  useEffect(() => {
    if (user && token) {
      dispatch(defineUser(user, token));
      Sentry.setDrugstoreUser(user);
      // Tentar identificar o usuário no Crazy Egg com retentativas
      retryIdentifyUserCrazyEggWithTimeout(user.id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user, token]);

  return (
    <ThemeProvider theme={theme}>
      <Styles.Container>
        <SentryContainer />
        <XRayTrackerContainer />
        <GlobalStyles />
        <BrowserRouter basename="/receita">
          <Routes />
          <ZendeskButton />
        </BrowserRouter>
      </Styles.Container>
    </ThemeProvider>
  );
};

const AppWrapper: React.FC = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;
